import React from 'react';
import StaffProfileTemplate, {
  ProfileSection,
  ProfileParagraphs,
  ProfileBullets,
  ProfileContactSection,
} from './StaffProfileTemplate';

const EstherSwuProfile = () => {
  const person = {
    id: 'esther-swu',
    name: 'Esther Swu',
    honorific: 'Ms',
    title: 'Assistant Researcher',
    affiliation: 'The Highland Institute, Kohima, Nagaland',
    image: 'https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/2zaty3t7_Esther%20Swu.jpg',
    email: 'esther@highlandinstitute.org',
    category: 'Research Staff',
    testid: 'esther-swu-profile',
  };

  return (
    <StaffProfileTemplate person={person}>
      <ProfileSection title="Research and Professional Biography">
        <ProfileParagraphs
          items={[
            'Esther Swu is an Assistant Researcher at The Highland Institute, Kohima, Nagaland, with an academic background in history, social research, and the interdisciplinary humanities. Her educational training also includes diplomas in computer applications and Sütsa, the Sumi Naga language, in which she graduated among the top-ranked students.',
            'Her professional experience spans historical research, cultural documentation, translation, digitisation, transcription, and collaborative academic projects. Since 2023, she has been associated with The Highland Institute, contributing to research initiatives focused on Naga society, memory, and cultural transformation.',
            <>
              For example, she worked as a Research Assistant on <strong>"Soldier-Citizens Labouring in the Border Security Force"</strong>, a collaboration between The Highland Institute and the National University of Singapore. The project explored complex historical experiences and identities within communities during an important period in Naga social history.
            </>,
            'Her collaborative research experience also included participation in a University of Göttingen project examining changes in cooking methods and dietary practices in Nagaland in the context of modernisation.',
            <>
              Swu was a Field Investigator on the ICSSR-funded minor research project <strong>"Phonetic Database and Digital Preservation of the Sumi Tribal Language: A Sociolinguistic and Cultural Study"</strong>. She is currently working as a Research Assistant on <strong>"Visual Histories of Northeast India: Digitising the Anthropological Photographs of Ahmed Hossain"</strong>, in collaboration with the Modern Endangered Archives Program (MEAP), UCLA.
            </>,
            'In addition to her research work, she is a dialect newsreader and translator, contributing to regional language communication and public outreach. She has also participated in the North East International Model United Nations, where she engaged in discussions on global issues such as climate change, diplomacy, and international relations.',
            'Her work reflects a continuing interest in Indigenous histories, oral traditions, cultural transitions, identity, and social change in Northeast India.',
          ]}
        />
      </ProfileSection>

      <ProfileSection title="Research Foci and Areas of Work">
        <ProfileBullets
          items={[
            'Naga history and society',
            'Indigenous histories and oral traditions',
            'Cultural memory and identity',
            'Political and social history of Northeast India',
            'Modernisation and cultural transformation in Nagaland',
            'Food culture, diet, and traditional cooking practices',
            'Translation and regional language communication',
            'Community-based and collaborative research methodologies',
            'Archival and ethnographic research',
            'Public history and heritage documentation',
          ]}
        />
      </ProfileSection>

      <ProfileSection title="Blog">
        <ul className="space-y-3 not-prose">
          <li className="text-stone-700 pl-4 border-l-2 border-green-600">
            <a
              href="https://blogs.highlanderpress.org/index.php/2026/02/09/shadows-of-the-past-memories-of-revolutionary-government-of-nagaland-members/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-700 hover:text-green-800 underline break-all"
            >
              Shadows of the Past: Memories of Revolutionary Government of Nagaland Members
            </a>
          </li>
        </ul>
      </ProfileSection>

      <ProfileSection title="Postgraduate Qualification">
        <ProfileBullets items={['MA in History']} />
      </ProfileSection>

      <ProfileContactSection
        email={person.email}
        role="Assistant Researcher, The Highland Institute"
        testidPrefix="esther"
        scholarlyProfiles={[
          { label: 'LinkedIn', url: 'https://www.linkedin.com/in/esther-swu-84038b409', testid: 'esther-linkedin-link' },
        ]}
      />
    </StaffProfileTemplate>
  );
};

export default EstherSwuProfile;
